import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@trevor/ui-components';
import css from '@/css/module/new-world.css';
import flex from '@/css/module/flex.css';
import { useLoadRows_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { useDataPresentationParam } from '@/hooks';
import { useLoadMoreResults } from '@/features/query-builder/fullQueryResultsApiSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  selectIsFullResultsLoaded,
  setFullResultsSeriesId,
} from '@/features/query-builder/queryBuilderSlice';

export const LoadMoreResults = () => {
  const dataPresentation = useDataPresentationParam();
  const dispatch = useAppDispatch();
  const { dataTable, isFetching } = useLoadRows_LEGACY();
  const [handleLoadFullResults, seriesId] = useLoadMoreResults();
  const areAllResultsLoaded = useAppSelector(selectIsFullResultsLoaded);

  React.useEffect(() => {
    if (seriesId) {
      dispatch(setFullResultsSeriesId(seriesId));
    }
  }, [seriesId]);

  if (!dataPresentation) return null;
  if (!dataTable) return null;
  if (dataTable._rows.length < 100) return null;
  if (areAllResultsLoaded) return null;

  return (
    <div style={{ alignSelf: 'center', marginTop: '15px' }}>
      <div className={css.section} style={{ display: 'inline-flex' }}>
        <div className={`${css.infoWarning} ${flex.alignItemsCenter}`}>
          <span>
            <span data-tip data-for="previewNote">
              <FontAwesomeIcon
                icon="info-circle"
                style={{ marginRight: '5px' }}
              />
            </span>
            <Tooltip id="previewNote">
              This limit does not apply on dashboards or when exporting results
            </Tooltip>
          </span>
          <span className="margin-right-5">
            Preview showing first 100 results
          </span>
          <span>
            <Button
              variant="secondary"
              data-tooltip-id="loadAllNote"
              style={{ fontSize: '10.8px' }}
              disabled={isFetching}
              onClick={handleLoadFullResults}
            >
              Load more
            </Button>
            <Tooltip id="loadAllNote">This can take several minutes</Tooltip>
          </span>
        </div>
      </div>
    </div>
  );
};
